import script from "./GlobalGMrotaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalGMrotaTable.vue?vue&type=script&setup=true&lang=js"

import "./GlobalGMrotaTable.vue?vue&type=style&index=0&id=16b41ef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b41ef2"]])

export default __exports__